// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BreadcrumbsRouteImport } from './routes/_breadcrumbs'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BreadcrumbsSluzbyRouteImport } from './routes/_breadcrumbs/sluzby'
import { Route as BreadcrumbsNotFoundPageRouteImport } from './routes/_breadcrumbs/not-found-page'
import { Route as BreadcrumbsKontaktyRouteImport } from './routes/_breadcrumbs/kontakty'
import { Route as BreadcrumbsReferenceBreadcrumbRouteImport } from './routes/_breadcrumbs/_referenceBreadcrumb'
import { Route as BreadcrumbsPageSlugRouteImport } from './routes/_breadcrumbs/$pageSlug'
import { Route as BreadcrumbsReferenceBreadcrumbReferenceIndexRouteImport } from './routes/_breadcrumbs/_referenceBreadcrumb/reference/index'
import { Route as BreadcrumbsReferenceBreadcrumbReferenceReferenceSlugRouteImport } from './routes/_breadcrumbs/_referenceBreadcrumb/reference/$referenceSlug'
import { Route as BreadcrumbsReferenceBreadcrumbReferenceKategorieCategorySlugRouteImport } from './routes/_breadcrumbs/_referenceBreadcrumb/reference/kategorie/$categorySlug'

const BreadcrumbsRoute = BreadcrumbsRouteImport.update({
            id: '/_breadcrumbs',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BreadcrumbsSluzbyRoute = BreadcrumbsSluzbyRouteImport.update({
            id: '/sluzby',path: '/sluzby',getParentRoute: () => BreadcrumbsRoute
          })
const BreadcrumbsNotFoundPageRoute = BreadcrumbsNotFoundPageRouteImport.update({
            id: '/not-found-page',path: '/not-found-page',getParentRoute: () => BreadcrumbsRoute
          })
const BreadcrumbsKontaktyRoute = BreadcrumbsKontaktyRouteImport.update({
            id: '/kontakty',path: '/kontakty',getParentRoute: () => BreadcrumbsRoute
          })
const BreadcrumbsReferenceBreadcrumbRoute = BreadcrumbsReferenceBreadcrumbRouteImport.update({
            id: '/_referenceBreadcrumb',getParentRoute: () => BreadcrumbsRoute
          })
const BreadcrumbsPageSlugRoute = BreadcrumbsPageSlugRouteImport.update({
            id: '/$pageSlug',path: '/$pageSlug',getParentRoute: () => BreadcrumbsRoute
          })
const BreadcrumbsReferenceBreadcrumbReferenceIndexRoute = BreadcrumbsReferenceBreadcrumbReferenceIndexRouteImport.update({
            id: '/reference/',path: '/reference/',getParentRoute: () => BreadcrumbsReferenceBreadcrumbRoute
          })
const BreadcrumbsReferenceBreadcrumbReferenceReferenceSlugRoute = BreadcrumbsReferenceBreadcrumbReferenceReferenceSlugRouteImport.update({
            id: '/reference/$referenceSlug',path: '/reference/$referenceSlug',getParentRoute: () => BreadcrumbsReferenceBreadcrumbRoute
          })
const BreadcrumbsReferenceBreadcrumbReferenceKategorieCategorySlugRoute = BreadcrumbsReferenceBreadcrumbReferenceKategorieCategorySlugRouteImport.update({
            id: '/reference/kategorie/$categorySlug',path: '/reference/kategorie/$categorySlug',getParentRoute: () => BreadcrumbsReferenceBreadcrumbRoute
          })





const BreadcrumbsReferenceBreadcrumbRouteChildren = {
  BreadcrumbsReferenceBreadcrumbReferenceReferenceSlugRoute: BreadcrumbsReferenceBreadcrumbReferenceReferenceSlugRoute,BreadcrumbsReferenceBreadcrumbReferenceIndexRoute: BreadcrumbsReferenceBreadcrumbReferenceIndexRoute,BreadcrumbsReferenceBreadcrumbReferenceKategorieCategorySlugRoute: BreadcrumbsReferenceBreadcrumbReferenceKategorieCategorySlugRoute
}

const BreadcrumbsReferenceBreadcrumbRouteWithChildren = BreadcrumbsReferenceBreadcrumbRoute._addFileChildren(BreadcrumbsReferenceBreadcrumbRouteChildren)



const BreadcrumbsRouteChildren = {
  BreadcrumbsPageSlugRoute: BreadcrumbsPageSlugRoute,BreadcrumbsReferenceBreadcrumbRoute: BreadcrumbsReferenceBreadcrumbRouteWithChildren,BreadcrumbsKontaktyRoute: BreadcrumbsKontaktyRoute,BreadcrumbsNotFoundPageRoute: BreadcrumbsNotFoundPageRoute,BreadcrumbsSluzbyRoute: BreadcrumbsSluzbyRoute
}

const BreadcrumbsRouteWithChildren = BreadcrumbsRoute._addFileChildren(BreadcrumbsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BreadcrumbsRoute: BreadcrumbsRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)